import alimentacao from '../static/icons/xs-logo-aliment.svg';
import auto from '../static/icons/xs-logo-auto.svg';
import compras from '../static/icons/xs-logo-compras.svg';
import cultura from '../static/icons/xs-logo-cult.svg';
import refeicao from '../static/icons/xs-logo-refeicao.svg';
import saude from '../static/icons/xs-logo-saude.svg';
import boasfestas from '../static/icons/xs-logo-boasfestas.svg';
import multibeneficios from '../static/icons/xs-logo-multi.svg';
import vrva from '../static/icons/xs-logo-vrva.svg';
import logoVR from '../static/icons/xs-logo-vr.svg';
import jvcefAlimentacao from '../static/icons/jvcef-alimentacao.png';
import jvcefRefeicao from '../static/icons/jvcef-refeicao.png';

export default function getIconByProduto(codigo) {
  const key = String(codigo).padStart(5, '0');
  switch (key) {
    case '00027':
      return alimentacao;
    case '00290':
      return jvcefAlimentacao;
    case '00031':
      return refeicao;
    case '00270':
      return jvcefRefeicao;
    case '00028':
      return auto;
    case '00030':
      return cultura;
    case '00202':
      return boasfestas;
    case '00203':
      return compras;
    case '00205':
      return saude;
    case '00207':
      return multibeneficios;
    case '00209':
      return vrva;
    default:
      return logoVR;
  }
}
